import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { RiskContainer, SanitariaStranieriQuotesStyles } from './styles/SanitariaPerStranieriResultPage.styles';
import ErrorComponent from '../../common/components/ErrorComponent';
import { confirmAlert, generalAlertError } from '../../common/utils/alerts';
import {
  addSanitariaStranieriQuoteToCart, removeSanitariaStranieriQuoteFromCart, sanitariaStranieriQuotesGetQuotes,
  sanitariaStranieriQuotesSilentGetQuotes,
} from '../../features/insuranceRequests/insuranceRequestsActions';
import { EstimateContainer } from '../../common/components/redesignComponents/common/Redesign.styles';
import SanitariaStranieriModalButtons from './components/SanitariaStranieriModalButtons';
import SanitariaStranieriModal from './components/SanitariaStranieriModal';
import PageLoading from '../../common/componentsV2/elements/PageLoading';
import ConversationModal from '../../common/components/redesignComponents/Modal/ConversationModal';
import { primaQuoteTypes } from '../../common/constants';
import { V2FontImport } from '../../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import SanitariaStranieriSummaryCard from '../../common/components/redesignComponents/ResultPageComponents/v2/SanitariaStranieriSummaryCard';
import QuoteCostSummaryCard from '../../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';
import {
  OutlineActionButton,
  ActionButtonBadge,
} from '../../common/components/redesignComponents/ResultPageComponents/v2/SecondaryActionButtons.styles';
import { ChatIcon } from '../../common/components/redesignComponents/ResultPageComponents/v2/ActionIcons';
import FailedQuotationsComponent from '../../common/components/redesignComponents/ResultPageComponents/v2/FailedQuotationsComponent';

function SanitariaPerStranieriResultPage() {
  const { requestToken } = useParams();
  const navigate = useNavigate();
  const {
    loading,
    error,
    insuranceRequest,
    customer,
    quotations,
    addingQuote,
    processingQuote,
    failedQuotes,
    riskQuotations,
    thread,
    est_provvigioni,
  } = useSelector((store) => store.insuranceRequests.sanitaria_stranieri_quotes);
  const [showConversationModal, setShowConversationModal] = useState(false);
  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  const refresh = () => sanitariaStranieriQuotesGetQuotes(requestToken);
  const silentRefresh = () => sanitariaStranieriQuotesSilentGetQuotes(requestToken);

  const modifyData = () => {
    navigate('/quote/sanitaria-stranieri', {
      state: { requestToken },
    });
  };

  const selectQuotation = (quoteId, closeButton) => {
    confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addSanitariaStranieriQuoteToCart(quoteId, refresh, modifyData, closeButton));
  };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeSanitariaStranieriQuoteFromCart(quoteId, refresh, modifyData));
  };

  useEffect(() => {
    sanitariaStranieriQuotesGetQuotes(requestToken);
  }, [requestToken]);

  const handleRequestPurchase = () => {
    if (processingQuote === null) {
      generalAlertError('Seleziona Prima La Responsabilita Civile', 'Errore');
      return;
    }

    navigate(`/quotes/sanitaria-stranieri/purchase/${requestToken}`);
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (riskQuotations && riskQuotations[type.id] !== undefined) {
        for (let i = 0; i < riskQuotations[type.id].length; i++) {
          const item = riskQuotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    return (quoteInProccessAmount + risksTotalAmount).toFixed(2);
  };

  if (loading) {
    return <PageLoading />;
  }

  if (error !== null) {
    return <ErrorComponent error={error} />;
  }

  return (
    <>
      {showConversationModal && (
        <ConversationModal
          requestId={insuranceRequest?.id}
          threadId={thread?.thread_id}
          onClose={() => {
            setShowConversationModal(false);
            silentRefresh();
          }}
          onUpdated={() => silentRefresh()}
          location="quotation_sanitaria_stranieri_result"
        />
      )}
      <V2FontImport />
      <SanitariaStranieriQuotesStyles>
        <div className="resultsPage">
          <ResultOverviewRow>
            <SanitariaStranieriSummaryCard
              customer={customer}
              insuranceRequest={insuranceRequest}
              modifyData={modifyData}
            />
            <QuoteCostSummaryCard
              processingQuote={processingQuote}
              quoteTypes={quoteTypes}
              riskQuotations={riskQuotations}
              primaQuoteTypes={primaQuoteTypes}
              getTotal={getTotal}
              onProcedi={() => handleRequestPurchase()}
              rcTypeLabel={processingQuote?.product_name}
              est_provvigioni={est_provvigioni}
            />
          </ResultOverviewRow>
          <div className="row">
            <div className="col-12 ">
              <EstimateContainer>
                <div className="d-flex gap-2 justify-content-end ">
                  <div>
                    {/* {localStorage.getItem('quoteNewResult') === 'done' && (
                      <div style={{ cursor: 'pointer' }} onClick={() => firePurchaseTour()}>
                        <button className="btn btn-success px-2 py-1">Tutorial</button>
                      </div>
                    )} */}
                    <OutlineActionButton
                      type="button"
                      onClick={() => {
                        setShowConversationModal(true);
                        if (thread?.unreadMessages > 0) silentRefresh();
                      }}
                    >
                      <ChatIcon />
                      Contatta il Backoffice
                      {thread?.unreadMessages > 0 && (
                        <ActionButtonBadge>
                          {thread.unreadMessages}
                          <span className="visually-hidden">messaggi non letti</span>
                        </ActionButtonBadge>
                      )}
                    </OutlineActionButton>
                  </div>
                </div>
              </EstimateContainer>
            </div>
          </div>

          {quotations && quotations.res_civile
            && (
              <>
                <RiskContainer className="mb-3 pb-3 result-home-third-step">
                  {quoteTypes.map((type, index) => (
                    <React.Fragment key={index}>
                      {quotations && quotations[type.id] && (
                        <SanitariaStranieriModalButtons
                          insuranceRequest={insuranceRequest}
                          processingQuote={processingQuote}
                          type={type}
                          removeItemFromCart={removeItemFromCart}
                          riskQuotations={riskQuotations}
                        />
                      )}
                    </React.Fragment>
                  ))}
                </RiskContainer>
                {quoteTypes.map((type, index) => (
                  <SanitariaStranieriModal
                    insuranceRequest={insuranceRequest}
                    type={type}
                    key={index}
                    addingQuote={addingQuote}
                    quotations={quotations}
                    selectQuotation={selectQuotation}
                    processingQuote={processingQuote}
                  />
                ))}
              </>
            )}
        </div>

        {failedQuotes !== null && failedQuotes.length > 0 && (
          <FailedQuotationsComponent failedQuotes={failedQuotes} />
        )}
      </SanitariaStranieriQuotesStyles>
    </>
  );
}

export default SanitariaPerStranieriResultPage;
